import { useState } from 'react';
import { Link } from 'wouter';
import rosenblumLogo from '@assets/RLF_Hori_Lockup.jpg';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  return (
    <nav className="bg-white shadow-sm" id="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center h-16">
          <div className="flex items-center">
            <Link href="/" className="flex items-center">
              <img 
                src={rosenblumLogo} 
                alt="Rosenblum Law" 
                className="h-8 w-auto" 
              />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
